import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";
import type {
    GroupedTechnologies,
    TechnologiesFilterDto,
} from "app/pages/sales-intelligence/modules/technology/types/technologies";
import {
    enforceAtMostOneExcludeCondition,
    isExcludeInclusionAvailable,
} from "app/pages/sales-intelligence/domain/inclusion/inclusionFilterConditionUtils";

export default class FindTechnologyFilter extends FilterPanelBaseFilter<TechnologiesFilterDto[], GroupedTechnologies> {
    isExcludeInclusionAvailable(conditions?: TechnologiesFilterDto[], editing?: TechnologiesFilterDto | null): boolean {
        return isExcludeInclusionAvailable(conditions ?? [], editing ?? null);
    }

    toApiValue(value?: TechnologiesFilterDto[]): TechnologiesFilterDto[] | undefined {
        if (!value?.length) {
            return undefined;
        }

        const filteredValue = enforceAtMostOneExcludeCondition(
            value.filter((item) => !this.isTechnologyItemEmpty(item)),
        );

        return filteredValue.length ? filteredValue : undefined;
    }

    private isTechnologyItemEmpty(item: TechnologiesFilterDto): boolean {
        return !item.parentCategories.length && !item.categories.length && !item.technologies.length;
    }
    constructor(deps: IFilterPanelBaseFilterDeps<TechnologiesFilterDto[], GroupedTechnologies>) {
        super(deps);
    }

    calculateValueDelta(
        previousValue: TechnologiesFilterDto[] | undefined,
        newValue: TechnologiesFilterDto[] | undefined,
    ): FilterValueDelta<TechnologiesFilterDto> {
        return calculateArrayDelta(previousValue, newValue);
    }
}
